import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';

import { OrderDetailsResponse } from '../models/order-details-response.model';

export interface MyOrderDetailsPricelessVariables {
  orderNumber: string;
  locale: string;
  ct_Locale: string;
}

@Injectable({
  providedIn: 'root',
})
export class MyOrderDetailsPricelessQuery extends Query<OrderDetailsResponse, MyOrderDetailsPricelessVariables> {
  // eslint-disable-next-line
  override document = gql`
    query ($orderNumber: String!, $locale: NonEmptyString!, $ct_Locale: ct_Locale!) {
      order(orderNumber: $orderNumber, locale: $locale) {
        id
        invoiceNumber
        country
        fulfillmentContactEmail
        fulfillmentContactKey
        fulfillmentContactName
        fulfillmentContactPhone
        fulfillmentDateTime
        fulfillmentTimeSlotStart
        fulfillmentTimeSlotEnd
        fulfillmentTimeZoneAbbreviation
        fulfillmentStoreTimeZoneId
        fulfillmentInstructions
        fulfillmentStoreKey
        fulfillmentStoreNumber
        currentStatus
        currentStatusReason
        fulfillmentStoreAddress {
          address1
          address2
          city
          postcode
          name
          countryCode
          state
          phoneNumber
          email
        }
        deliveryAddressKey
        orderNumber
        shippingAddress {
          address1
          address2
          city
          postcode
          name
          countryCode
          state
          key
          phoneNumber
          email
        }
        shippingMethodName
        key
        lineItems {
          sourceTopLevelCategory
          tintedProduct {
            colorName
            colorCode
            hexColorCode
            paletteName
            paletteCode
            baseId
          }
          customColorInformation {
            configurableMaterialSku
            description
            tintBase
            product {
              name(locale: $ct_Locale)
              slug(locale: $ct_Locale)
              description(locale: $ct_Locale)
              masterVariant {
                finishTypeGlossGrade(locale: $ct_Locale)
                netVolume
                volumeUOM
                productGroupID
                colourbankProductCode
                assets {
                  sources {
                    uri
                    dimensions {
                      width
                      height
                    }
                    contentType
                  }
                }
              }
            }
          }
          color
          colorHex
          productType
          itemTypes
          finishTypeGlossGrade
          sku
          exportCatalogSku
          showSku
          frontImage
          productName
          productNameInEnglish
          size
          quantity
          id
          productGroupId
          netVolume
          volumeUOM
          colourbankProductCode
          assets {
            uri
            contentType
          }
          brand
          isInCatalogProduct
          storeOrderNumber
          canBeReturned
          returnActionUrl
          isSameSiteOrder
        }
      }
    }
  `;
}
